import styled from 'styled-components';

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.neutral[500]};
  margin-bottom: 0;
`;
